import { Box, Paper, Stack, Typography } from '@mui/material';

import { signInStep1AskUserToLogin } from '@/domain/auth/actions/sign-in-step1-ask-user-to-login.action';
import { signUpAskUserToCreateAccount } from '@/domain/auth/actions/sign-up-ask-user-to-create-account.action';
import FairlyBackgroundLogo from '@/ui/assets/logo-fairly-background.png';
import { FSPrimaryButton } from '@/ui/components/button/FSPrimaryButton';
import { useDialogConfirm } from '@/ui/components/confirm-dialog/useDialogConfirm';
import { FSLink } from '@/ui/components/FSLink';
import { Logo } from '@/ui/components/Logo';
import { useAppDispatch } from '@/ui/hook/store';
import { translate } from '@/ui/i18n';

export function Login() {
  const dispatch = useAppDispatch();
  const dialogConfirm = useDialogConfirm();

  const onClickSignIn = async () => {
    dispatch(signInStep1AskUserToLogin());
  };

  const termsOfUseUrl = import.meta.env.VITE_URL_TERMS_OF_USE;
  const legalNoticeUrl = import.meta.env.VITE_URL_LEGAL_NOTICE;

  const onClickSignUp = async () => {
    const response = await dialogConfirm({
      content: (
        <>
          <Typography sx={{ paddingTop: 2, paddingBottom: 2 }}>
            {translate('Login.term-of-use-dialog.text')}{' '}
            <FSLink href={termsOfUseUrl} target="_blank">
              {translate('Login.term-of-use-dialog.text-link')}
            </FSLink>
            .
          </Typography>
        </>
      ),
      acknowledgement: translate('Login.term-of-use-dialog.checkbox'),
    });
    if (response === 'confirmed') {
      dispatch(signUpAskUserToCreateAccount());
    }
  };

  return (
    <Box
      sx={{
        height: '100vh',
        background: `no-repeat url(${FairlyBackgroundLogo})`,
        backgroundSize: 'contain',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          position: 'relative',
          height: '100%',
        }}
      >
        <Box sx={{ mt: 8 }}>
          <Logo />
        </Box>
        <Paper
          elevation={3}
          sx={{
            py: 2,
            px: 3,
            borderRadius: '28px',
            minWidth: 400,
            display: 'flex',
            flexDirection: 'column',
            position: 'absolute',
            top: '45%',
            transform: 'translate(0, -50%)',
            backgroundImage: 'none',
          }}
        >
          <Typography variant="h6">{translate('Login.connexion')}</Typography>
          <Stack sx={{ mt: 8, mb: 4, alignSelf: 'center', gap: 2 }}>
            <FSPrimaryButton onClick={onClickSignIn}>
              {translate('Login.signin-button')}
            </FSPrimaryButton>
            <FSPrimaryButton color="info" onClick={onClickSignUp}>
              {translate('Login.signup-button')}
            </FSPrimaryButton>
          </Stack>
          <Box sx={{ alignSelf: 'center', mt: 3 }}>
            <FSLink
              href={legalNoticeUrl}
              target="_blank"
              color={'inherit'}
              underline="hover"
            >
              {translate('Login.legal-notice')}
            </FSLink>
          </Box>
        </Paper>
      </Box>
    </Box>
  );
}
